import type { CaseView } from '../../../../shared/components/CheckSimilarAppointment/fetchSimilarCase'
import { environment } from '../../../../shared/utils/fetchEnv/env'
import { getBlaize } from '../../../../shared/utils/getBlaize'

export type MemberNotAuthorised = {
  isAuthorised: false
}

export type ChangePastAppointment = {
  isSupported: boolean
  isUpcoming: false
  caseView: CaseView
  isAuthorised: true
}
export type ChangeFutureAppointment = {
  isUpcoming: true
  changeAppointmentUrl: string
  isAuthorised: true
}
export type ChangeAppointmentResponse =
  | ChangePastAppointment
  | ChangeFutureAppointment
  | MemberNotAuthorised

export const getChangeAppointmentUrl = async (
  appointmentId: string
): Promise<ChangeAppointmentResponse> => {
  const response = await fetch(
    `https://${environment()}-appointment-booking-rebooking-service.api.product.which.co.uk/rebooking-service/change-appointment?appointmentId=${appointmentId}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getBlaize(),
        'User-Agent': window.navigator.userAgent,
        'X-Forwarded-Application': `which-tool-framework/${environment()}`,
      },
    }
  )

  if (!response.ok) {
    throw new Error('unexpected response')
  }

  return await response.json()
}
